import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useSuiteStore } from '@/stores/useSuiteStore'
import { withApiState } from '@/utils/withApiState'

export type StatsPeriod = 'week' | 'month' | 'year'

interface StatValue {
  value: number
  delta: number
  deltaSign: 'up' | 'down' | 'flat'
}

interface StatsBundle {
  companiesWithAccess: StatValue
  companiesActive: StatValue
  contactsWithAccess: StatValue
  contactsActive: StatValue
  ticketsCreated: StatValue
}

export interface ClientSpaceStatsResponse {
  period: StatsPeriod
  current: { since: string; until: string }
  previous: { since: string; until: string }
  stats: StatsBundle
}

export const useEspaceClientStatsStore = defineStore('espaceClientStats', () => {
  const suiteStore = useSuiteStore()
  const stats = ref<ClientSpaceStatsResponse | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  async function fetchStats(period: StatsPeriod): Promise<ClientSpaceStatsResponse | null> {
    const result = await withApiState(
      async () => {
        const res = await suiteStore.suiteFetch(`client-space/admin/stats?period=${period}`, {
          method: 'GET',
          credentials: 'include',
        })
        if (res && typeof res !== 'boolean' && res.ok) {
          stats.value = (await res.json()) as ClientSpaceStatsResponse
          return stats.value
        }
        error.value = 'Impossible de charger les statistiques'
        return null
      },
      { loading: isLoading, error, errorText: 'Erreur réseau', logLabel: 'Erreur récupération stats espace client' },
    )
    return result ?? null
  }

  return { stats, isLoading, error, fetchStats }
})
